import React from 'react';

import { FooterContentEntity } from '../../shared/footer/domain/entities/FooterContentEntity';
import FooterViewCmp from '../../shared/footer/view/components/FooterViewCmp';
import { HeaderContentEntity } from '../../shared/header/domain/entities/HeaderContentEntity';
import HeaderViewCmp from '../../shared/header/view/components/HeaderViewCmp';
import { SeoWithSchema } from '../../shared/helpers/SeoMetaMapper';

import LayoutShell from './LayoutShell';
import { useMainLayout } from './useMainLayout';

// MigrationNote: `meta_data.schemas` is forwarded to the TS SEOCmp as
// `local_data` byte-for-byte, matching MainLayout.res. ReScript-backed pages
// pass a ReScript list, TS-migrated pages a JS array — SEOCmp normalizes both
// shapes (plus undefined from SEO.t-shaped view models) before rendering
// JSON-LD.

interface MainLayoutProps {
  children: React.ReactNode;
  header_data: HeaderContentEntity;
  footer_data: FooterContentEntity;
  meta_data: SeoWithSchema;
  has_fare_estimate_button?: boolean;
  show_download_sticky?: boolean;
}

function MainLayout({
  children,
  header_data,
  footer_data,
  meta_data,
  has_fare_estimate_button = false,
  show_download_sticky = true,
}: Readonly<MainLayoutProps>): React.ReactElement {
  const bindings = useMainLayout({ persistQuery: true });

  return (
    <LayoutShell
      metaData={meta_data}
      bindings={bindings}
      header={
        <HeaderViewCmp
          data={header_data}
          show_download_sticky={show_download_sticky}
        />
      }
      footer={
        <FooterViewCmp
          footer_data={footer_data}
          has_fare_estimate_button={has_fare_estimate_button}
        />
      }
    >
      {children}
    </LayoutShell>
  );
}

export default MainLayout;
